/* Copyright (c) Trimble Inc. All rights reserved. */

export { trackGainsightEvent, toGainsightErrorReason } from './Gainsight.tracker';
export type { GainsightEventProperties } from './Gainsight.tracker';
